// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1Y6Of","content":"ManualTimeModal_content__ad9RJ"};